import * as React from 'react';
import { Box, Card, CardContent, Typography, OutlinedInput, FormLabel, Button, Slider } from '@mui/material';
import { Add, RemoveCircle } from '@mui/icons-material';
import { useAppContext } from '../contexts/AppContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useEffect } from 'react';

const RewardsForm: React.FC<any> = ({ initialValues }) => {
  const [rewards, setRewards] = React.useState<any[]>(initialValues || [{ name: '', value: 100 }]);

  const { appState, updateAppState } = useAppContext();
  const { translations } = useLanguage(); // ✅ Get translations


  useEffect(() => {
    updateAppState({ newStoreRewards: rewards });
  }, [rewards]);

  const handleAddReward = () => {
    if (rewards.length < 10) {
      setRewards([...rewards, { name: '', value: 100 }]); // Adds a new empty reward
    }
  };

  const handleRemoveReward = (index: number) => {
    const updatedRewards = rewards.filter((_, i) => i !== index);
    setRewards(updatedRewards); // Removes the reward at the specified index
  };

  const handleChangeReward = (index: number, field: 'name' | 'value', value: string | number | number[]) => {
    const updatedRewards = [...rewards];
    updatedRewards[index] = { ...updatedRewards[index], [field]: value };
    setRewards(updatedRewards);
  };

  function valuetext(value: number) {
    return `${value} ${translations.store_creation_section.points}`;
  }

  return (
    <Box>
      <Typography
        sx={{
          color: "red",
          fontSize: '0.875rem',
          mb: 2,
        }}
      >
        {translations.store_creation_section.rewards_info}
      </Typography>

      <FormLabel htmlFor="reward-2" required>
        {translations.store_creation_section.define_offers}
      </FormLabel>

      {/* Reward cards */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {rewards.map((reward, index) => (
          <Card key={index}>
            <CardContent sx={{ position: 'relative' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {/* Reward Name */}
                <Box>
                  <FormLabel htmlFor={`reward-name-${index}`} required>
                    {translations.store_creation_section.reward_name}
                  </FormLabel>
                  <OutlinedInput
                    id={`reward-name-${index}`}
                    value={reward.name}
                    onChange={(e) => handleChangeReward(index, 'name', e.target.value)}
                    placeholder={translations.store_creation_section.reward_name_placeholder}
                    required
                    fullWidth
                  />
                </Box>

                {/* Reward Points */}
                <Box>
                  <FormLabel htmlFor={`reward-value-${index}`} required>
                    {translations.store_creation_section.points_required}: {reward.value}
                  </FormLabel>
                  <Slider
                    aria-label="Points Required"
                    getAriaValueText={valuetext}
                    valueLabelDisplay="auto"
                    marks
                    defaultValue={reward.value ?? 100}
                    value={reward.value}
                    step={10}
                    min={10}
                    max={300}
                    color='success'
                    onChange={(e, value) => handleChangeReward(index, 'value', value)}
                  />
                </Box>
                <Button
                  variant="outlined"
                  disabled={rewards.length === 1}
                  onClick={() => handleRemoveReward(index)}
                  sx={{
                    alignSelf: 'center',
                    justifySelf: 'center',
                  }}
                  endIcon={<RemoveCircle />}>
                  {translations.store_creation_section.points_required}: {reward.value}
                </Button>
              </Box>

              {/* Remove reward button */}
            </CardContent>
          </Card>
        ))}
      </Box>

      {/* Button to add a new reward at the bottom */}
      <Box sx={{
        mt: 2,
        alignSelf: 'center',
        justifySelf: 'center',

      }}>

        <Button
          variant="outlined"
          onClick={handleAddReward}
          disabled={rewards.length >= 10}
          endIcon={<Add />}
        >
          {translations.store_creation_section.add_offer}
        </Button>
      </Box>
    </Box>
  );
}

export default RewardsForm;